
import RepeateOne from "../../../assets/filled/RepeateOne.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RepeateOneIcon({ className, dataTestid = "RepeateOneIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RepeateOne data-testid={dataTestid} className={classes} {...rest} />
  );
}
